// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"c5d7c6a3","453":"e9cce0ac","455":"b5ff4314","977":"64dffc9a"}[chunkId] + ".chunk.js";
};